module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_geweld.5a668f9b.svg";